import { graphql } from "../gql";

export const getFileUserAnnotationsQueryDoc = graphql(`
  query getFileUserAnnotations($fileId: ID!) {
    fileUserAnnotations(fileId: $fileId) {
      ...FileUserAnnotationFragment
      creator {
        ...AuditorUserFragment
      }
    }
  }
`);
